import React from "react";
import Vector from "../../assets/popups/verified.png";
import dangerIcon from "../../assets/popups/productDeleted.png";
import { Modal, ModalBody } from "react-bootstrap";
import "../modals/modal.css";

const EnabledDisabledPopUp = ({ show, title, status }) => {
  return (
    <Modal
      centered
      show={show}
      // onHide={handleClose}
      dialogClassName="my-modal"
    >
      <ModalBody className="m-4 p-4">
        <div className="p-2">
          {status == true ? (
            <img
              src={dangerIcon}
              alt="mail"
              className=" mx-auto d-block"
              style={{ height: "30px" }}
            />
          ) : (
            <img
              src={Vector}
              alt="mail"
              className=" mx-auto d-block"
              style={{ height: "30px" }}
            />
          )}

          <p
            className="fn_Nunito fw_600 fs_22 color_262c3d my-2 px-0"
            style={{ textAlign: "center", fontSize: "20px" }}
          >
            {title} {status == true ? "Disabled" : "Enabled"}
          </p>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EnabledDisabledPopUp;
